import * as React from 'react';
import _pick from 'lodash/pick';
import warning from 'warning';
import classnames from 'classnames';
import Dropdown from './Dropdown';
import Item from './Item';
import { NavItemPropType } from './_types';
export { NavItemPropType };

var HeaderNav = function HeaderNav(props) {
  var items = props.items,
      className = props.className;

  var _items = items.map(function (item, index) {
    var key = item.key || index;

    var baseProps = _pick(item, ['title', 'icon']);

    if (!('children' in item)) {
      var url = item.url,
          onClick = item.onClick;
      return React.createElement(Item, Object.assign({}, baseProps, {
        key: key,
        url: url,
        onClick: onClick
      }));
    }

    warning(!('url' in item), "Un \xE9l\xE9ment de la navigation header ne peut pas \xEAtre un dropdown et un lien vers " + "une autre page en m\xEAme temps, il faut soit sp\xE9cifier la cl\xE9 `children` soit la " + "cl\xE9 `url`, mais pas les deux en m\xEAme temps.");
    var children = item.children;
    return React.createElement(Dropdown, Object.assign({}, baseProps, {
      key: key,
      items: children || []
    }));
  });

  var _className = classnames(className, 'HeaderNav');

  return React.createElement("ul", {
    className: _className
  }, _items);
};

HeaderNav.defaultProps = {
  className: ''
};
HeaderNav.displayName = 'Header.Nav';
export default HeaderNav;